"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ach/ach-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fach%2Fach-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AchServiceClient = exports.RelinkResponse = exports.RelinkRequest = exports.GetRelinkingTokenResponse = exports.GetRelinkingTokenRequest = exports.RefreshBalanceResponse = exports.RefreshBalanceRequest = exports.AddAccountResponse = exports.AddAccountRequest = exports.GetLinkingTokenResponse = exports.GetLinkingTokenRequest = exports.LinkingToken = exports.FakeLinkingRequest = exports.PlaidLinkingRequest = exports.LinkingRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const ach_account_1 = require("../common/ach-account");
const external_account_1 = require("../common/external-account");
const external_bank_1 = require("../common/external-bank");
const protobufPackage = 'com.step.ach.proto';
function createBaseLinkingRequest() {
    return { manual: undefined, plaid: undefined, fake: undefined };
}
exports.LinkingRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.manual)) {
            message.manual = exports.FakeLinkingRequest.fromJSON(object.manual);
        }
        if (isSet(object.plaid)) {
            message.plaid = exports.PlaidLinkingRequest.fromJSON(object.plaid);
        }
        if (isSet(object.fake)) {
            message.fake = exports.FakeLinkingRequest.fromJSON(object.fake);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.manual !== undefined) {
            obj.manual = exports.FakeLinkingRequest.toJSON(message.manual);
        }
        if (message.plaid !== undefined) {
            obj.plaid = exports.PlaidLinkingRequest.toJSON(message.plaid);
        }
        if (message.fake !== undefined) {
            obj.fake = exports.FakeLinkingRequest.toJSON(message.fake);
        }
        return obj;
    },
    create(base) {
        return exports.LinkingRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLinkingRequest();
        message.manual = (object.manual !== undefined && object.manual !== null)
            ? exports.FakeLinkingRequest.fromPartial(object.manual)
            : undefined;
        message.plaid = (object.plaid !== undefined && object.plaid !== null)
            ? exports.PlaidLinkingRequest.fromPartial(object.plaid)
            : undefined;
        message.fake = (object.fake !== undefined && object.fake !== null)
            ? exports.FakeLinkingRequest.fromPartial(object.fake)
            : undefined;
        return message;
    },
};
function createBasePlaidLinkingRequest() {
    return { publicToken: '', accountId: '' };
}
exports.PlaidLinkingRequest = {
    fromJSON(object) {
        const message = {
            publicToken: isSet(object.publicToken) ? globalThis.String(object.publicToken) : '',
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.publicToken !== '') {
            obj.publicToken = message.publicToken;
        }
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.PlaidLinkingRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlaidLinkingRequest();
        message.publicToken = object.publicToken ?? '';
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseFakeLinkingRequest() {
    return {
        account: ach_account_1.AchAccount.fromPartial({}),
        accountType: ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE,
        accountHolderName: '',
        bankName: '',
    };
}
exports.FakeLinkingRequest = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account)
                ? ach_account_1.AchAccount.fromJSON(object.account)
                : ach_account_1.AchAccount.fromPartial({}),
            accountType: isSet(object.accountType)
                ? (0, ach_account_1.achAccountTypeFromJSON)(object.accountType)
                : ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE,
        };
        if (isSet(object.accountHolderName)) {
            message.accountHolderName = globalThis.String(object.accountHolderName);
        }
        if (isSet(object.bankName)) {
            message.bankName = globalThis.String(object.bankName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = ach_account_1.AchAccount.toJSON(message.account);
        }
        if (message.accountType !== ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE) {
            obj.accountType = (0, ach_account_1.achAccountTypeToJSON)(message.accountType);
        }
        if (message.accountHolderName !== undefined && message.accountHolderName !== '') {
            obj.accountHolderName = message.accountHolderName;
        }
        if (message.bankName !== undefined && message.bankName !== '') {
            obj.bankName = message.bankName;
        }
        return obj;
    },
    create(base) {
        return exports.FakeLinkingRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFakeLinkingRequest();
        message.account = (object.account !== undefined && object.account !== null)
            ? ach_account_1.AchAccount.fromPartial(object.account)
            : ach_account_1.AchAccount.fromPartial({});
        message.accountType = object.accountType ?? ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE;
        message.accountHolderName = object.accountHolderName ?? '';
        message.bankName = object.bankName ?? '';
        return message;
    },
};
function createBaseLinkingToken() {
    return { token: '', expiresAtMs: '0' };
}
exports.LinkingToken = {
    fromJSON(object) {
        const message = {
            token: isSet(object.token) ? globalThis.String(object.token) : '',
            expiresAtMs: isSet(object.expiresAtMs) ? globalThis.String(object.expiresAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== '') {
            obj.token = message.token;
        }
        if (message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.LinkingToken.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLinkingToken();
        message.token = object.token ?? '';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        return message;
    },
};
function createBaseGetLinkingTokenRequest() {
    return { provider: external_bank_1.BankProvider.INVALID_BANK_PROVIDER };
}
exports.GetLinkingTokenRequest = {
    fromJSON(object) {
        const message = {
            provider: isSet(object.provider)
                ? (0, external_bank_1.bankProviderFromJSON)(object.provider)
                : external_bank_1.BankProvider.INVALID_BANK_PROVIDER,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.provider !== external_bank_1.BankProvider.INVALID_BANK_PROVIDER) {
            obj.provider = (0, external_bank_1.bankProviderToJSON)(message.provider);
        }
        return obj;
    },
    create(base) {
        return exports.GetLinkingTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLinkingTokenRequest();
        message.provider = object.provider ?? external_bank_1.BankProvider.INVALID_BANK_PROVIDER;
        return message;
    },
};
function createBaseGetLinkingTokenResponse() {
    return { linkingToken: exports.LinkingToken.fromPartial({}) };
}
exports.GetLinkingTokenResponse = {
    fromJSON(object) {
        const message = {
            linkingToken: isSet(object.linkingToken)
                ? exports.LinkingToken.fromJSON(object.linkingToken)
                : exports.LinkingToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.linkingToken !== undefined) {
            obj.linkingToken = exports.LinkingToken.toJSON(message.linkingToken);
        }
        return obj;
    },
    create(base) {
        return exports.GetLinkingTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetLinkingTokenResponse();
        message.linkingToken = (object.linkingToken !== undefined && object.linkingToken !== null)
            ? exports.LinkingToken.fromPartial(object.linkingToken)
            : exports.LinkingToken.fromPartial({});
        return message;
    },
};
function createBaseAddAccountRequest() {
    return { request: exports.LinkingRequest.fromPartial({}), name: '' };
}
exports.AddAccountRequest = {
    fromJSON(object) {
        const message = {
            request: isSet(object.request)
                ? exports.LinkingRequest.fromJSON(object.request)
                : exports.LinkingRequest.fromPartial({}),
            name: isSet(object.name) ? globalThis.String(object.name) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.request !== undefined) {
            obj.request = exports.LinkingRequest.toJSON(message.request);
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return exports.AddAccountRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddAccountRequest();
        message.request = (object.request !== undefined && object.request !== null)
            ? exports.LinkingRequest.fromPartial(object.request)
            : exports.LinkingRequest.fromPartial({});
        message.name = object.name ?? '';
        return message;
    },
};
function createBaseAddAccountResponse() {
    return { account: external_account_1.ExternalAccount.fromPartial({}) };
}
exports.AddAccountResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account)
                ? external_account_1.ExternalAccount.fromJSON(object.account)
                : external_account_1.ExternalAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = external_account_1.ExternalAccount.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.AddAccountResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddAccountResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? external_account_1.ExternalAccount.fromPartial(object.account)
            : external_account_1.ExternalAccount.fromPartial({});
        return message;
    },
};
function createBaseRefreshBalanceRequest() {
    return { externalAccountId: '' };
}
exports.RefreshBalanceRequest = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.RefreshBalanceRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRefreshBalanceRequest();
        message.externalAccountId = object.externalAccountId ?? '';
        return message;
    },
};
function createBaseRefreshBalanceResponse() {
    return { account: external_account_1.ExternalAccount.fromPartial({}) };
}
exports.RefreshBalanceResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account)
                ? external_account_1.ExternalAccount.fromJSON(object.account)
                : external_account_1.ExternalAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = external_account_1.ExternalAccount.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.RefreshBalanceResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRefreshBalanceResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? external_account_1.ExternalAccount.fromPartial(object.account)
            : external_account_1.ExternalAccount.fromPartial({});
        return message;
    },
};
function createBaseGetRelinkingTokenRequest() {
    return { externalAccountId: '' };
}
exports.GetRelinkingTokenRequest = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetRelinkingTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRelinkingTokenRequest();
        message.externalAccountId = object.externalAccountId ?? '';
        return message;
    },
};
function createBaseGetRelinkingTokenResponse() {
    return { linkingToken: exports.LinkingToken.fromPartial({}) };
}
exports.GetRelinkingTokenResponse = {
    fromJSON(object) {
        const message = {
            linkingToken: isSet(object.linkingToken)
                ? exports.LinkingToken.fromJSON(object.linkingToken)
                : exports.LinkingToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.linkingToken !== undefined) {
            obj.linkingToken = exports.LinkingToken.toJSON(message.linkingToken);
        }
        return obj;
    },
    create(base) {
        return exports.GetRelinkingTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRelinkingTokenResponse();
        message.linkingToken = (object.linkingToken !== undefined && object.linkingToken !== null)
            ? exports.LinkingToken.fromPartial(object.linkingToken)
            : exports.LinkingToken.fromPartial({});
        return message;
    },
};
function createBaseRelinkRequest() {
    return { externalAccountId: '' };
}
exports.RelinkRequest = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.RelinkRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRelinkRequest();
        message.externalAccountId = object.externalAccountId ?? '';
        return message;
    },
};
function createBaseRelinkResponse() {
    return { account: external_account_1.ExternalAccount.fromPartial({}) };
}
exports.RelinkResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account)
                ? external_account_1.ExternalAccount.fromJSON(object.account)
                : external_account_1.ExternalAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = external_account_1.ExternalAccount.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.RelinkResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRelinkResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? external_account_1.ExternalAccount.fromPartial(object.account)
            : external_account_1.ExternalAccount.fromPartial({});
        return message;
    },
};
/**
 * ACH public API.
 */
class AchServiceClient {
    rpc;
    name = 'com.step.ach.proto.AchService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/ach';
    methods = [{
            name: 'GetLinkingToken',
            requestType: exports.GetLinkingTokenRequest,
            responseType: exports.GetLinkingTokenResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'AddAccount',
            requestType: exports.AddAccountRequest,
            responseType: exports.AddAccountResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RefreshBalance',
            requestType: exports.RefreshBalanceRequest,
            responseType: exports.RefreshBalanceResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetRelinkingToken',
            requestType: exports.GetRelinkingTokenRequest,
            responseType: exports.GetRelinkingTokenResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Relink',
            requestType: exports.RelinkRequest,
            responseType: exports.RelinkResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Returns a linking token to be used to initiate client-side account linking
     * with the given provider.
     */
    getLinkingToken(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Adds an external bank account.
     */
    addAccount(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Refreshes external bank account balance and returns this account.
     */
    refreshBalance(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a linking token to be used to re-initiate client-side account
     * linking of an expired account.
     */
    getRelinkingToken(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Completes the relinking process of an expired account.
     */
    relink(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.AchServiceClient = AchServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=ach-service.js.map